import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function FacebookPixelTracker() {
  const location = useLocation();

  // Facebook Pixel Tracking
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }

    if (location.pathname.startsWith('/donate/detail/')) {
      if (window.fbq) {
        window.fbq('track', 'Donate');
      }
    }
  }, [location]);

  // Google / GA4 Tracking
useEffect(() => {
  if (typeof window.gtag !== 'function') return;

  const pagePath = location.pathname + location.search;

  // GA4 page tracking
  window.gtag('config', 'G-L06DYGQRQK', {
    page_path: pagePath,
  });


  window.gtag('config', 'AW-11128358980', {
    page_path: pagePath,
  });

}, [location]);

  return null;
}

export default FacebookPixelTracker;